import React, { useState, useEffect, useRef } from 'react';
import logo from '../../space.webp';
import Cookies from 'universal-cookie';
import './editViews.css';

import loading from '../../img/loading.gif';
import { decryptAes, storeKey, encryptAes, _arrayBufferToBase64 } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import clip from './../../img/clip.png';
import home from './../../img/home.png';
import persons from './../../img/profile.png';
import car from './../../img/car.png';
import company from './../../img/company.png';
import crime from './../../img/crime.png';
import phoneInterner from './../../img/phoneInterner.png';
import event from './../../img/event.png';
import documents from './../../img/document.png';
import weapon from './../../img/weapon.png';
import bs from './../../img/bs.png';
import headPhone from './../../img/headphone.png';
import plus from './../../img/plus.png'
import minus from './../../img/minus.png'
import PersonModel from '../models/PersonModel';
import SearchModel from '../models/SearchModel';
import ModelForAdd from '../models/ModelForAdd';

import Person from '../components/Person';
import Address from '../components/Address';
import Company from '../components/Company';
import Auto from '../components/Auto';
import Contact from '../components/Contact';
import Document from '../components/Document';
import Gun from '../components/Gun';
import OPM from '../components/OPM';
import Traitor from '../components/Traitor';
import BS from '../components/BS';
import Kan from '../components/Kan';
import SunEditor, { buttonList } from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import { Buffer } from 'buffer'
import {
    createChecker, createCheckerLabel, createCheckerInput,
    createPerson, createTraitor, createPersonCollapsed, createTraitorCollapsed,
    createAddressCollapsed, createAutoCollapsed, createCompanyCollapsed, createContactCollapsed,
    createGunCollapsed, createDocCollapsed, createArchCollapsed, createOPMCollapsed, createBSCollapsed, createKanCollapsed,
    showError
} from '../ViewCreator';
import AddressModel from '../models/AddressModel';
import AutoModel from '../models/AutoModel';
import CompanyModel from '../models/CompanyModel';
import ContactModel from '../models/ContactModel';
import DocumentModel from '../models/DocumentModel';
import GunModel from '../models/GunModel';
import OPMModel from '../models/OPMModel';
import TraitorModel from '../models/TraitorModel';
import KanModel from '../models/KanModel';
import BSModel from '../models/BSModel';
import MyDropzone from '../components/MyDropzone';

var modelForAdd = (new ModelForAdd());
var personModel = (new PersonModel());
const cookies = new Cookies();
function GunEdit() {

    var searchModel = new SearchModel();

    const editor = useRef();
    const getSunEditorInstance = (sunEditor) => {
        editor.current = sunEditor;
    };

    const [isBlocked, setIsBlocked] = useState(false);

    const blockUI = () => {
        setIsBlocked(true);
    };

    const unblockUI = () => {
        setIsBlocked(false);
    };

    const [type, setType] = useState(0);

    const mainSubmit = () => {
        window.location.href = "/main";
    };

    const addNew = (id, type) => {
        
        clearPersonModel()
        if (type === 20000) {
            var per = new PersonModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.persons.push(per);
        } else if (type === 20001) {
            var per = new AddressModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.addresses.push(per);
        } else if (type === 20002) {
            var per = new AutoModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.auto.push(per);
        } else if (type === 20003) {
            var per = new CompanyModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.company.push(per);
        } else if (type === 20004) {
            var per = new ContactModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.contact.push(per);
        } else if (type === 20005) {
            var per = new DocumentModel()
            per.id = id
            personModel.documents.push(per);
        } else if (type === 20006) {
            var per = new GunModel()
            per.id = id
            personModel.gun.push(per);
        } else if (type === 20008) {
            var per = new OPMModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.opm.push(per);
        } else if (type === 20009) {
            var per = new TraitorModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.traitors.push(per);
        } else if (type === 20010) {
            var per = new KanModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.kan.push(per);
        } else if (type === 20011) {
            var per = new BSModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.bs.push(per);
        } else if (type === 20012){
            var files = id
            for (let index = 0; index < files.length; index++) {
                const reader = new FileReader()
                reader.onabort = () => console.log('file reading was aborted')
                reader.onerror = () => console.log('file reading has failed')
                reader.onload = () => {
                // Do whatever you want with the file contents
                  const binaryStr = reader.result
                  var ex = "";
                  if (files[index].path == undefined) {
                    ex = files[index].name.split('.').pop().toLowerCase();
                  } else {
                    ex = files[index].path.split('.').pop().toLowerCase();
                  }
                  if (ex == 'bmp' || ex == 'gif' || ex == 'jpeg' || ex == 'jpg' || ex == 'tiff' || ex == 'png') {
                    var b = _arrayBufferToBase64(binaryStr)
                    var tt = {
                      image: b,
                      text: ""
                    }
                    personModel.photo.push(tt)
                    
                    
                  } else {
            
            
            
            
            
                    
                    var b = _arrayBufferToBase64(binaryStr)
            
            
            
            
                    
                    var tt = {
                      
                        fileName: files[index].name,
                        file: b,
                      
                      
                      text: "",
                      
                    }

                    
                      personModel.files.push(tt)
                    
                  }

                  sendReSave()
                }
                reader.readAsArrayBuffer(files[index])
              }
           
        } else if (type === 20013){
            var tt = {
                image: id,
                text: ""
              }
            personModel.photo.push(tt)
        }

        if (type !== 20012){
         sendReSave()
        }
    }

    useEffect(() => {
        if (cookies.get('type') != null) {
            var t = cookies.get('type')
            setType(t);
        }
        const queryParams = new URLSearchParams(window.location.search);
        const id = queryParams.get("id");
        sendPerson(id);
    }, []);

    const sendPerson = (id) => {
        var path = ip + '/api/gun/info';
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                    
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);


                    var zz = []

                    var pers = result.data
                    personModel = (pers)
                    setView(pers)

                }
            })
    }

    const profileSubmit = () => {
        
    }


    const handleKeyPress = (event) => {
        event = event || window.event;
        if (event.key === 'Tab') {
            closeAllHelp();
        }
        if (event.key === 'Enter') {
            closeAllHelp();
        }
        if (event.key === 'Escape') {
            closeAllHelp();
        }
    }

    const closeAllHelp = () => {
        var a = document.getElementsByClassName("list");
        for (let index = 0; index < a.length; index++) {
            a[index].innerHTML = "";
        }
    }
    const changedfield = (id) => {
        var input = document.getElementById(id + "A")
        if (input != null) {
            if (input.value.length > 0) {
                document.getElementById(id + "AList").innerHTML = "";
                sendHelp(input.value, id);
            } else {
                document.getElementById(id + "AList").innerHTML = "";
            }
        }
    }

    const sendHelp = (value, id) => {
        var path = ip + '/api/help/';
        var bd = encryptAes(JSON.stringify({
            "value": value,
            "type": id
        }))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    var l = result.data.list;
                    for (let index = 0; index < l.length; index++) {
                        var z = document.createElement('div'); // is a node
                        z.className = "listItem"
                        z.innerHTML = l[index];
                        z.style.display = "block";
                        z.href = "#";
                        z.onclick = () => {

                            document.getElementById(id + "A").value = l[index]
                            document.getElementById(id + "AList").innerHTML = "";


                            if(id=='typeGun'){
                        
                                personModel.typeGun = l[index]
                               
                              }
                              if(id=='numberGun'){
                                personModel.numberGun = l[index]
                              
                              }
        
                              if (id == 'descGun'){
                                personModel.descGun = l[index]
                              }


                        }
                        document.getElementById(id + "AList").appendChild(z);

                    }
                }
            })








    }


    const descGunchange = () => {
        personModel.descGun = document.getElementById('descGunA').value
        changedfield('descGun');
    }

    const numberGunchange = () => {
        personModel.numberGun = document.getElementById('numberGunA').value
        changedfield('numberGun');
    }
    const typeGunchange = () => {
        personModel.typeGun = document.getElementById('typeGunA').value
        changedfield('typeGun');
    }
    
    const handleFocus = (event) => {
        closeAllHelp()
    };

    const sendSave = () => {
        blockUI()
        var path = ip + '/api/gun/addData';

        personModel.persons = []
        personModel.addresses = []
        personModel.auto = []
        personModel.company = []
        personModel.contact = []
        personModel.documents = []
        personModel.gun = []
        personModel.opm = []
        personModel.photo = []
        personModel.files = []
        personModel.traitor = []
    
          if (personModel.typeGun == undefined || personModel.typeGun == ''){
            showError('Тип не може бути пустим')
            return;
          }
    
          if (personModel.numberGun == undefined || personModel.numberGun == ''){
            showError('Номер не може бути пустим')
            return;
          }

        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                unblockUI()
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);


                }
            })
    }

    const sendRemove = (inner) => {
        blockUI()
        var path = ip + '/api/gun/removeData';

        var bd = encryptAes(JSON.stringify(inner))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                unblockUI()
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);
                    document.getElementById("addeditems").innerHTML = "";
                    personModel = (result.data)
                    setView(result.data)

                }
            })
    }

    const handleSubmit = (e) => {
        sendSave()

        e.preventDefault();
    }

    const getAvatarToComponent = async(id, style, el) => {
        var path = ip + '/files/avatar';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);


                    var a = document.getElementById('image' + id)
                   

                    if (a !== null) {
                        a.src = 'data:image/png;base64,'+result.data
                        a.className = style
                      }
                       el.src = 'data:image/png;base64,'+result.data
                       el.className = style
                }
                
              
          }   
      )
    }

    const sendReSave = () => {
        blockUI()
        var path = ip + '/api/gun/addData';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                unblockUI()
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    personModel = (result.data)
                    setView(result.data)

                }
            })
    }

    const sendPersonFullScreen = (id) => {
        window.open("/person?id=" + id)
    }

    function clearPersonModel() {
        personModel.persons = []
        personModel.addresses = []
        personModel.auto = []
        personModel.company = []
        personModel.contact = []
        personModel.contacts = []
        personModel.documents = []
        personModel.gun = []
        personModel.guns = []
        personModel.opms = []
        personModel.opm = []
        personModel.photos = []
        personModel.photo = []
        personModel.files = []
        personModel.docs = []
        personModel.kan = []
        personModel.bs = []
        personModel.traitors = []
    }


    const changeSearch = (inner) => {

        var a = document.getElementById("foundItems");
        a.innerHTML = ""
        for (let index = 0; index < inner.length; index++) {
            var z = document.createElement('div'); // is a node
            var vv = document.createElement('div');
            vv.className = "itemAddView"
            z.style.display = "table";
            vv.style.display = "table-cell";
            inner[index].style = "table-cell"
            var vb = document.createElement('div');
            vb.className = "itemAddButton"
            vb.innerHTML = "<img width=\"100%\" src=\"" + plus + "\"/>"
            if (document.getElementById("Person").style.display == "block") {
                var temp = modelForAdd.person
                const cl = i => () => {
                    var b = true;

                    if (modelForAdd.person.length > 0){
                        showError('Може бути привязана тільки одна особа')
                    } else {

                    for (let j = 0; j < modelForAdd.person.length; j++) {
                        if (modelForAdd.person[j].value.id == inner[index].value.id) {
                            b = false
                        }
                    }
                    if (b) {
                        clearPersonModel()
                        inner[index].value.relStatus = 0
                        inner[index].value.relDesk = ""
                        personModel.persons.push(inner[index].value);
                        sendReSave()
                    } else {
                        showError('Данний запис уже існує');
                    }
                }
                }
                vb.onclick = cl(inner[index].value)
            }
            vv.appendChild(vb)
            z.appendChild(vv);
            z.appendChild(inner[index]);
            a.appendChild(z);

        }
    }

    const resetModel = () => {
        modelForAdd = new ModelForAdd()
    };

    const setView = (pers, obj) => {
        document.getElementById('typeGunA').value = pers.typeGun
  document.getElementById('numberGunA').value = pers.numberGun
  document.getElementById('descGunA').value = pers.descGun

     
        resetModel()
        if (pers.persons !== undefined) {

            
                addNewPerson(pers.persons, false)
                

            
        }
        changeAdded()
    }

    const addNewPerson = (pers, isNewAdd = true) => {
        var z = document.createElement('div'); // is a node
        z.className = "listItem"
        var s = "<p align=\"left\">";
        var sn = (pers.lastName == undefined || pers.lastName == '' ? "" : pers.lastName + " ") +
            (pers.firstName == undefined || pers.firstName == '' ? "" : pers.firstName + " ") +
            (pers.middleName == undefined || pers.middleName == '' ? "" : pers.middleName + " ");
        var sb = (pers.bDate == undefined || pers.bDate == '' ? "" : pers.bDate + " ") +
            (pers.bLocation == undefined || pers.bLocation == '' ? "" : pers.bLocation + " ");
        var sc = (pers.nationality == undefined || pers.nationality == '' ? "" : pers.nationality + " ") +
            (pers.citizen == undefined || pers.citizen == '' ? "" : pers.citizen + " ");
        s += (sn == undefined || sn == '' ? "" : sn + "<br>") +
            (sb == undefined || sb == '' ? "" : sb + "<br>") +
            (sc == undefined || sc == '' ? "" : sc + "<br>") +
            (pers.nikName == undefined || pers.nikName == '' ? "" : pers.nikName + "<br>");

        if (pers.criminal == undefined || pers.criminal == '') {
            pers.criminal = 'Ні'
        }

        if (pers.criminal == "Так") {
            s += "Cудимий<br>"
        }
        s += (pers.desc == undefined || pers.desc === '' ? "" : pers.desc + "<br>");
        z.innerHTML = s
        z.style.display = "block";

        z.value = Object.assign({}, pers);


        var p = Object.assign({}, pers);
        if (p.firstName == undefined || p.firstName == '') {
            z.value = pers
            p = pers

        }

        if (p.firstName == undefined || p.firstName == '') {
            showError('Ім\'я зв\'язка не може бути пустим')
            return;
        }

        if (p.lastName == undefined || p.lastName == '') {
            showError('Прізвище зв\'язка не може бути пустим')
            return;
        }

        if (p.middleName == undefined || p.middleName == '') {
            showError('По батькові зв\'язка не може бути пустим')
            return;
        }

        if (p.bDate == undefined || p.bDate == '') {
            showError('Рік народження зв\'язка не може бути пустим')
            return;
        }


        if (isNewAdd) {

            clearPersonModel()
            z.value.relStatus = 0
            z.value.relDesk = ""

            personModel.persons.push(z.value);

            sendReSave()
        } else {

            modelForAdd.person.push(z)

            changeAdded()
        }
    }

    const changeAdded = () => {

        var a = document.getElementById("addeditems");
        a.innerHTML = ""
        if (document.getElementById("Person").style.display == "block") {
            for (let index = 0; index < modelForAdd.person.length; index++) {
                var z = document.createElement('div');
                z.className = "itemAddViewFull"
                var vv = document.createElement('div');
                vv.className = "itemAddView"
                z.style.display = "table";
                vv.style.display = "table-cell";
                modelForAdd.person[index].style = "table-cell"
                var vb = document.createElement('div');
                vb.className = "itemAddButton"
                vb.innerHTML = "<img width=\"100%\" src=\"" + minus + "\"/>"
                const cl = i => () => {
                    Swal.fire({
                        title: 'Підтвердіть виделаення запису',
                        icon: 'question',
                        html: '',
                        showDenyButton: false,
                        showCancelButton: true,
                        confirmButtonText: 'Видалити',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                        if (result.isConfirmed) {
                        const queryParams = new URLSearchParams(window.location.search);
                        const id = queryParams.get("id");
                        var id2 = i.id
                        sendRemove([id, id2, 20000])
                        }
                    })
                }
                vb.onclick = cl(modelForAdd.person[index].value)
               
                vv.appendChild(vb)
                z.appendChild(vv);
                var d = document.createElement('div');
                d.innerHTML = modelForAdd.person[index].innerHTML;
                const dlcl = i => () => {
                   sendPersonFullScreen(i)
                }
                d.ondblclick = dlcl(modelForAdd.person[index].value.id);
                z.appendChild(d);
                a.appendChild(z);
            }

        }

    }









    return (
        <div className="fixed inset-0 bg-black z-50">

            <div className="main">
                <div className="header">
                    <img src={logo} className="logo" alt="logo" />
                    <div className="title" onClick={mainSubmit}>SPACE</div>
                    <div className="subtitle">(edit) </div>

                </div>

                <div className="panel">

                    <button id="personsB" className="panelButtonActive-single" onClick={profileSubmit} >
                        <img src={persons} className="panelImage" />
                    </button>
                    
                </div>

                <div className="searchMenu">

                    <form onSubmit={handleSubmit} className="form">


                        <input id="saveButton" className="input-button-right-auto" type="submit" value="Зберегти" />

          <div id="descGunADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="descGunA" className="input-text" tabIndex="3" name="login" type="text" onChange={descGunchange}  placeholder="Опис" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="descGunAList" className="list" />
          </div>

          <div id="numberGunADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="numberGunA" className="input-text" tabIndex="2" name="login" type="text" onChange={numberGunchange}  placeholder="Номер" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="numberGunAList" className="list" />
          </div>

          <div id="typeGunADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="typeGunA" className="input-text" tabIndex="1" name="login" type="text" onChange={typeGunchange}  placeholder="Тип зброї" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="typeGunAList" className="list" />
          </div>
          


                    </form>

                </div>

                <div className="searc2hMenu" >
                    <div id="Person" className="menuItems" style={{ display: "block" }}>
                        <Person changeSearch={changeSearch} searchModel={searchModel} setView={setView} addNew={addNew} isAdd={true}/>
                    </div>
                   

                </div>


                <table width="100%" style={{ tableLayout: "fixed", width: "100%", borderCollapse: "collapse" }} >
                    <tbody>
                        <td style={{ width: "350px", maxWidth: "350px", overflow: "hidden", whiteSpace: "nowrap" }}>

                        </td>
                        <td style={{ width: "600px", maxWidth: "600px", overflow: "hidden", wordWrap: "break-word" }}>
                            <div id="addeditems">

                            </div>
                        </td>
                        <td id="tdline" style={{ width: "1px", maxWidth: "1px", overflow: "hidden" }}>
                            <div id="line">

                            </div>
                        </td>
                        <td style={{ width: "600px", maxWidth: "600px", overflow: "hidden", wordWrap: "break-word" }}>
                            <div id="foundItems">

                            </div>
                        </td>
                        <td style={{ width: "350px", maxWidth: "350px", overflow: "hidden", whiteSpace: "nowrap" }}>

                        </td>
                       
                    </tbody>
                </table>
            </div>

            ({isBlocked && <div className={`black ${isBlocked ? "show" : ""}`}>
                <img src={loading} alt="logo" />

            </div>
            })
        </div>

    );
}


export default GunEdit;